import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const deleteAdminBom = createAsyncThunk(
    "/admin/delete-bom",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/delete-bom/${id}`;
            const response = await axios({
                method: "delete",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to delete BOM");
            }
        } catch (error) {
            console.error("Error in deleteAdminBom:", error);
            toast.error(error.response?.data?.message || "Failed to delete BOM");
            throw error;
        }
    }
);

const deleteAdminBomSlice = createSlice({
    name: "deleteAdminBom",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteAdminBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAdminBom.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteAdminBom.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default deleteAdminBomSlice.reducer;
